import { setPermissions } from './utils'

export const setExportSyncWidget = ({ agentPermissions }) => {
    const permission = 'module.property.synchronization'
    const hasPermission = setPermissions(agentPermissions, permission)

    return { hasPermission }
}
